import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator, Logger } from 'ngrx-data';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { I1FilenetServices } from '../i1-filenet-services.service';
import { UserDataService } from '../userData/user-data.service';
import { ObjectStore } from './object-store.dto';

@Injectable({
    providedIn: 'root',
})
export class ObjectStoreDataService extends DefaultDataService<ObjectStore> {
    constructor(
        http: HttpClient,
        httpUserGenerator: HttpUrlGenerator,
        @Optional() logger: Logger,
        private i1FilenetServices: I1FilenetServices,
        private userDataService: UserDataService
    ) {
        super('ObjectStore', http, httpUserGenerator);
    }

    getAll(): Observable<ObjectStore[]> {
        return this.i1FilenetServices.getObjectStores().pipe(
            tap(v => this.userDataService.setUsername(v.username)),
            tap(v => this.userDataService.setFullname(v.fullname)),
            map(v => v.data),
            map(v => {
                return v.map(row => {
                    return { id: row.name, ...row } as ObjectStore;
                });
            }),
            map(v =>
                v.length === 0
                    ? [
                          {
                              id: 'NONE',
                              name: 'NONE',
                              superUser: false,
                              symbolicName: 'NO ACCESS',
                              initiatorUser: false
                          },
                      ]
                    : v
            )
        );
    }
}
